import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FAQ() {
  const [expanded, setExpanded] = React.useState<string[]>([]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(
        isExpanded
          ? [...expanded, panel]
          : expanded.filter((item) => item !== panel),
      );
    };

  return (
    <Container
      id="faq"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Typography
        component="h2"
        variant="h4"
        sx={{
          color: 'text.primary',
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' },
        }}
      >
        Dúvidas Frequentes
      </Typography>
      <Box sx={{ width: '100%' }}>
        <Accordion
          expanded={expanded.includes('panel1')}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            <Typography component="span" variant="subtitle2">
              O que é a Nextalk e como ela pode me ajudar?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ maxWidth: { sm: '100%', md: '70%' } }}
            >
              A Nextalk é uma ferramenta, desenvolvida pelo Grupo Cabanalink, que cria assistentes virtuais com inteligência artificial que automatizam todo o atendimento no WhatsApp da sua empresa, com naturalidade humana, permitindo que seus clientes tenham respostas rápidas para perguntas frequentes, além de concluir vendas ou agendamentos de forma rápida e eficiente. A Nextalk foi projetada para ajudar principalmente pequenos empreendedores a economizar tempo e melhorar a experiência dos seus clientes.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded.includes('panel2')}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            <Typography component="span" variant="subtitle2">
              Preciso ter conhecimento técnico para usar a ferramenta?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ maxWidth: { sm: '100%', md: '70%' } }}
            >
              Não! Nós montamos tudo para você.
              Mas caso você queira personalizar seu próprio fluxo, oferecemos uma interface intuitiva, tutoriais, suporte técnico, além de templates prontos para você começar em minutos.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded.includes('panel3')}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2d-content"
            id="panel2d-header"
          >
            <Typography component="span" variant="subtitle2">
              Em quanto tempo meu assistente estará funcionando?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ maxWidth: { sm: '100%', md: '70%' } }}
            >
              O processo de configuração inicial é muito rápido. Após a contratação, você responderá um formulário para conhecermos melhor o seu negócio para que o assistente realmente pareça um funcionário seu. Após isso você fará uma interação de teste e, após sua aprovação, o assistente estará pronto para uso em menos de 24 horas.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded.includes('panel4')}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3d-content"
            id="panel3d-header"
          >
            <Typography component="span" variant="subtitle2">
              Posso cancelar se a ferramenta não atender minhas necessidades?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ maxWidth: { sm: '100%', md: '70%' } }}
            >
              Sim! Oferecemos garantia de reembolso de 7 dias após o pagamento. Se você não estiver satisfeito com a ferramenta neste período,
              devolveremos 100% do seu dinheiro. Além disso, nossos planos não possuem fidelidade, então você pode cancelar a qualquer momento
              sem multas ou taxas adicionais.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded.includes('panel5')}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4d-content"
            id="panel4d-header"
          >
            <Typography component="span" variant="subtitle2">
              Por que escolher o assistente inteligente Nextalk?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ maxWidth: { sm: '100%', md: '70%' } }}
            >
              Oferecemos a melhor relação custo-benefício do mercado, com preços até 80% menores que a concorrência.
              A ferramenta foi projetada para atender prinicipalmente aos pequenos empreendedores, com preços acessíveis e funcionalidades completas.
              Além disso, nossa plataforma é fácil de usar, possui suporte técnico prioritário e funciona com qualquer número de WhatsApp.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded.includes('panel6')}
          onChange={handleChange('panel6')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5d-content"
            id="panel5d-header"
          >
            <Typography component="span" variant="subtitle2">
              Como posso obter ajuda se precisar?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ maxWidth: { sm: '100%', md: '70%' } }}
            >
              Nossa equipe de suporte está disponível por e-mail em&nbsp;
              <Link href="mailto:suporte@cabanalink.com">suporte@cabanalink.com</Link>
              &nbsp;e também via WhatsApp. Além disso, oferecemos tutoriais
              detalhados e uma base de conhecimento completa.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
}